import { Link } from "react-router-dom";
import { Typography, Button, Tooltip } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconEdit, IconLock } from "@tabler/icons-react";
import { BackButton } from "@/components/button";

interface SubscriptionDetailHeaderProps {
  name: string;
  subscriptionId: string;
  readOnly?: boolean;
}

const SubscriptionDetailHeader = ({
  name,
  subscriptionId,
  readOnly = false,
}: SubscriptionDetailHeaderProps) => {
  return (
    <Stack direction="row" align="center" justify="between">
      <Stack direction="row" gap="md" align="center">
        <BackButton defaultUrl="/subscriptions" />
        <Typography variant="page-heading" className="al-text-gray-900">
          {name}
        </Typography>
        {readOnly && (
          <Tooltip title="This subscription was created in Playground and cannot be edited here">
            <Stack direction="row" align="center">
              <IconLock size={18} className="al-text-gray-500" />
            </Stack>
          </Tooltip>
        )}
      </Stack>
      {!readOnly && (
        <Button asChild className="al-bg-blue-600 hover:al-bg-blue-700">
          <Link to={`/subscriptions/${subscriptionId}/edit`}>
            <IconEdit size={18} />
            Edit Subscription
          </Link>
        </Button>
      )}
    </Stack>
  );
};

export default SubscriptionDetailHeader;
